<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-snackbar v-model="error" color="red darken-2">
        <b>{{ errorMessage }} </b>
      </v-snackbar>

      <v-card>
        <v-card-title>
          <v-col class="d-flex" cols="4">
            Manager Reviews for year :
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              v-model="selectedCampaign"
              item-text="year"
              item-value="year"
              :items="getCampaigns"
              dense
              solo
              hide-details
              @change="changeCurrentYear($event)"
            >
            </v-select>
          </v-col>
          <v-col class="d-flex" cols="5">
            <v-text-field
              v-model="filter"
              label="Filter on first name or last name"
              @keyup="filterReview($event)"
              @click="filterReview($event)"
            ></v-text-field>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="general-background">
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Employee</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Part 1 & 2 Status</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Part 3 & 4 Status</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:10%">
                    <b>Year</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Strong Line Manager</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Dotted Line Manager</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:10%">
                    <b>Action</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="review in reviews" v-bind:key="review.id">
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ review.user.firstName }} {{ review.user.lastName }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{
                      review.reviewFirstPart.status
                        ? review.reviewFirstPart.status.label
                        : ""
                    }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{
                      review.reviewSecondPart.status
                        ? review.reviewSecondPart.status.label
                        : ""
                    }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ review.campaign.year }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    <span>
                      {{
                        review.slmanager != undefined
                          ? review.slmanager.firstName
                          : ""
                      }}
                      {{
                        review.slmanager != undefined
                          ? review.slmanager.lastName
                          : ""
                      }}&nbsp;
                      <v-tooltip bottom v-if="review.connectedSlmManager">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            :color="getColorFromReviewStatus(review, 'sl')"
                            v-on="on"
                          >
                            mdi-shield-star-outline
                          </v-icon>
                        </template>
                        <span>{{ getLabelForBadge(review, "sl") }}</span>
                      </v-tooltip>
                    </span>
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    <span>
                      {{
                        review.dlmanager != undefined
                          ? review.dlmanager.firstName
                          : ""
                      }}
                      {{
                        review.dlmanager != undefined
                          ? review.dlmanager.lastName
                          : ""
                      }}&nbsp;
                      <v-tooltip bottom v-if="review.connectedDlmManager">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            :color="getColorFromReviewStatus(review, 'dl')"
                            v-on="on"
                          >
                            mdi-shield-star-outline
                          </v-icon>
                        </template>
                        <span>{{ getLabelForBadge(review, "dl") }}</span>
                      </v-tooltip>
                    </span>
                  </th>
                  <th
                    v-if="review.connectedSlmManager"
                    class="text-left border-elem text-center"
                    style="width:auto !important"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          icon
                          :to="'/managerReview/sl/' + review.id"
                          class="btn-action"
                        >
                          <v-icon small>mdi-lead-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span> Show PDR</span>
                    </v-tooltip>
                  </th>
                  <th
                    v-else-if="review.connectedDlmManager"
                    class="text-left border-elem text-center"
                    style="width:auto !important"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          icon
                          :to="'/managerReview/dl/' + review.id"
                          class="btn-action"
                        >
                          <v-icon small>mdi-lead-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span> Show PDR</span>
                    </v-tooltip>
                  </th>
                  <th
                    v-else-if="review.connectedNewSlmManager"
                    class="text-left border-elem text-center"
                    style="width:auto !important"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          icon
                          :to="'/managerReview/sl/' + review.id"
                          class="btn-action"
                        >
                          <v-icon small>mdi-lead-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span> Show PDR</span>
                    </v-tooltip>
                  </th>
                  <th
                    v-else-if="review.connectedNewDlmManager"
                    class="text-left border-elem text-center"
                    style="width:auto !important"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          icon
                          :to="'/managerReview/dl/' + review.id"
                          class="btn-action"
                        >
                          <v-icon small>mdi-lead-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span> Show PDR</span>
                    </v-tooltip>
                  </th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style scoped>
.btn-action:hover {
  cursor: pointer;
  color: #00695c !important;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "managerReview",
  data() {
    return {
      selectedCampaign: "",
      reviews: [],
      error: false,
      errorMessage: "",
      filter: "",
      filteredReviews: [],
      originalReviews: [],
    };
  },
  computed: {
    ...mapGetters({
      getCampaign: "getCampaign",
      getCampaigns: "getCampaigns",
      user: "auth/user",
    }),
  },
  methods: {
      isActionForConnectedManager(curReview, status) {
        if (status == "sl") {
          //for sl manager check if status starts by 2 or 4
          if (curReview.reviewFirstPart.status) {
            if (
              curReview.reviewFirstPart.status.label.includes("2") ||
              curReview.reviewFirstPart.status.label.includes("4")
            ) {
              return true;
            }
          }
          if (curReview.reviewSecondPart.status) {
            if (
              curReview.reviewSecondPart.status.label.includes("2") ||
              curReview.reviewSecondPart.status.label.includes("4")
            ) {
              return true;
            }
          }
          return false;
        } else {
          //for dl manager check if status starts by 3
          if (
            (curReview.reviewFirstPart.status &&
              curReview.reviewFirstPart.status.label.includes("3")) ||
            (curReview.reviewSecondPart.status &&
              curReview.reviewSecondPart.status.label.includes("3"))
          ) {
            return true;
          } else {
            return false;
          }
        }
      },
      getColorFromReviewStatus(curReview, status) {
        if (this.isActionForConnectedManager(curReview, status)) {
          return "red";
        } else {
          return "";
        }
      },
      getLabelForBadge(curReview, status) {
        var text = "RIEN";

        if (this.isActionForConnectedManager(curReview, status)) {
          text = "Waiting your action";
        } else {
          text = "No action required from you";
        }
        return text;
      },
      changeCurrentYear: function() {
        this.$store.dispatch("setCampaign", {
          year: this.selectedCampaign,
        });
        this.loadReviews();
      },
      filterReview: function() {
        if (!this.filter || this.filter.length == 0) {
          this.resetFilter();
        } else {
          this.resetFilter();
          this.filteredReviews = [];
          this.originalReviews.forEach((review) => {
            if (
              review.user.firstName.toLowerCase().includes(this.filter.toLowerCase()) ||
              review.user.lastName.toLowerCase().includes(this.filter.toLowerCase())
            ) {
              this.filteredReviews.push(review);
            }
          });
          this.reviews = this.filteredReviews;
        }
      },
      resetFilter: function() {
        this.reviews = this.originalReviews;
      },
      loadReviews: function() {
        fetch(
          process.env.VUE_APP_ROOT_API_PATH +
            "api/reviews/manager/" +
            this.selectedCampaign,
          {
            method: "GET",
            credentials: "include",
          }
        )
          .then((response) => {
            if (response.status == "200") {
              return response.json();
            }
          })
          .then((json) => {
            if (json) {
              this.reviews = json.data;
              this.originalReviews = JSON.parse(JSON.stringify(json.data));
            }
          });
      },
    },
    mounted: function() {
      this.user.langue;
      if (
        !this.getCampaign ||
        !this.getCampaigns ||
        this.getCampaigns.length == 0
      ) {
                this.error = false;
//        this.error = true;
//        this.errorMessage = "There is no campaign actually opened";
      } else {
        this.selectedCampaign = this.getCampaign;
        this.loadReviews();
      }
    },
};
</script>
<style>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}
</style>
